import React, { useState } from 'react';
import { Modal, Input, Button, Form, message } from 'antd';
import { reviewLiveKeyRequest } from '../../../services/apiKeyRequestService';
import { showLoader, hideLoader } from '../../../utils/loader';

const { TextArea } = Input;

const ReviewApiKeyRequestModal = ({ visible, onCancel, onSuccess, request }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const isPending = (request?.status || 'PENDING').toUpperCase() === 'PENDING';

  const handleReview = async (approved) => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      showLoader();

      const response = await reviewLiveKeyRequest(request.requestId, approved, values.comment);

      if (response.status) {
        message.success(`Request ${approved ? 'approved' : 'rejected'} successfully`);
        form.resetFields();
        onSuccess();
      } else {
        message.error(response.message || 'Failed to submit review');
      }
    } catch (error) {
      console.error('Validation failed:', error);
    } finally {
      setLoading(false);
      hideLoader();
    }
  };

  const renderViewDetail = (label, value) => (
    <div style={{ marginBottom: 12, borderBottom: '1px solid #f0f0f0', paddingBottom: 8 }}>
      <div style={{ fontSize: 12, color: '#8c8c8c', textTransform: 'uppercase', marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 14, fontWeight: 500, color: '#262626' }}>{value || '—'}</div>
    </div>
  );

  return (
    <Modal
      title={isPending ? "Review Live API Key Request" : "API Key Request Details"}
      open={visible}
      onCancel={onCancel}
      footer={isPending ? [
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="reject"
          danger
          onClick={() => handleReview(false)}
          loading={loading}
        >
          Reject
        </Button>,
        <Button
          key="approve"
          type="primary"
          onClick={() => handleReview(true)}
          loading={loading}
          style={{ background: '#ff6700', borderColor: '#ff6700' }}
        >
          Approve
        </Button>,
      ] : [
        <Button key="close" type="primary" onClick={onCancel} style={{ background: '#ff6700', borderColor: '#ff6700' }}>
          Close
        </Button>
      ]}
      width={isPending ? 520 : 640}
    >
      {isPending ? (
        <>
          <div style={{ marginBottom: 16 }}>
            <p><strong>Merchant:</strong> {request?.merchantName || 'N/A'}</p>
          </div>

          <Form form={form} layout="vertical">
            <Form.Item
              name="comment"
              label="Review Comment"
              rules={[{ required: true, message: 'Please provide a comment' }]}
            >
              <TextArea
                rows={4}
                placeholder="Enter your review comment here (mandatory)..."
              />
            </Form.Item>
          </Form>
        </>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 24px' }}>
          {renderViewDetail('Merchant Name', request?.merchantName)}
          {renderViewDetail('Merchant ID', request?.merchantId)}
          {renderViewDetail('Status', request?.status)}
          {renderViewDetail('Admin Comment', request?.comment || request?.adminComment)}
          {renderViewDetail('Requested At', request?.createdAt ? new Date(request.createdAt).toLocaleString() : null)}
          {renderViewDetail('Reviewed At', request?.reviewedAt ? new Date(request.reviewedAt).toLocaleString() : null)}
        </div>
      )}
    </Modal>
  );
};

export default ReviewApiKeyRequestModal;
